export default __webpack_public_path__ + "static/media/soccer.9dc7bb99.jpg";